import React from 'react';
import defaultStyles from './index.module.scss';

interface props {
  inputValue: string;
  setInputValue: (value: string) => void;
  placeholder?: string;
  dynamicStyle?: React.CSSProperties;
  staticStyle?: Record<string, string>;
  isValid?: boolean;
  isDisabled?: boolean;
}

const InputSimple: React.FC<props> = ({
  isDisabled = false,
  inputValue,
  setInputValue,
  placeholder = '',
  dynamicStyle,
  staticStyle = defaultStyles,
  isValid = true
}) => {
  return (
    <input
      disabled={isDisabled}
      className={
        isValid ? staticStyle.simpleInput : staticStyle.simpleInputInvalid
      }
      value={inputValue}
      onChange={(e) => setInputValue(e.target.value)}
      placeholder={placeholder}
      style={dynamicStyle}
    />
  );
};

export default InputSimple;
